import { UserMatchingDto } from "@api-types/user/UserMatchingDto";
import { CreateUserDto } from "@data-types/membership/registration";
import CaptchaService from "@services/captcha/CaptchaService";
import { httpClient } from "@utils";
import { getApplicationHeaders } from "@utils";
import { httpClientLugas } from "@utils/http/httpClientLugas";

class PlatformRegistrationApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/gp/register`;
	}

	static getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async registerTerminalUser(
		body: CreateUserDto,
		terminalShopId: string
	): Promise<Response> {
		const token = await CaptchaService.executeCaptcha(
			"terminalRegistration"
		);

		if (token) {
			body.challengeResponse = token;
		}

		return httpClient.post(
			`${this.baseUrl}/retail-on-web`,
			JSON.stringify(body),
			{
				...this.getRequestHeaders(),
				"Shop-Id": terminalShopId,
			}
		);
	}

	static async registerUser(body: CreateUserDto) {
		const token = await CaptchaService.executeCaptcha("registration");

		if (token) {
			body.challengeResponse = token;
		}

		return await httpClientLugas.post(
			`${this.baseUrl}`,
			JSON.stringify(body),
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}

	static async confirmUserMatchingAndCompleteRegistration(
		userMatchingDto: UserMatchingDto
	) {
		return await httpClientLugas.post(
			`${this.baseUrl}/confirm-match-and-complete-registration`,
			JSON.stringify(userMatchingDto),
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}

	static registrationActivate(username: string, mailkey: string) {
		return httpClient.put(
			`${this.baseUrl}/activate/${username}/${mailkey}`,
			null,
			this.getRequestHeaders()
		);
	}
}

export default PlatformRegistrationApiService;
